class Instance {

    /*
    |--------------------------------------------------------------------------
    | Get instance
    |--------------------------------------------------------------------------
    |
    | Instance is appended to query params by Wix when run in iframe.
    | https://dev.wix.com/api/cli/example-app-walkthrough/communicate-with-the-backend#example-app-walkthrough_communicate-with-the-backend_instance-id
    |
    */

    static get = () => {
        return new URLSearchParams(window.location.search).get('instance')!;
    }
}

export default Instance;